import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NewPermanentLinkModal } from '@medflex/components/stories/PhysicianInvitePhysician';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import { trackEvent } from '@medflex/utils/Tracking';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import { MODALS } from '../hooks/useIsModal';
import useModal from '../hooks/useModal';

const NewPermanentLinkModule = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('physician');
  const { open } = useModal();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { permanentLink: errors = {} } = useSelector(state => state.errors);
  const { id } = useLocationSearchParams();
  const updateJoinLink = () => dispatch.sessions.updateJoinLink({ id });
  const { sessions: errorsJoinLink } = useSelector(state => state.errors);
  const isLoadingJoinLink = useSelector(state => state.loading.effects.sessions.updateJoinLink);

  const handleClose = () => {
    return open({ modal: MODALS.sessionChatDetail, type: '' });
  };

  const handleGenerateNew = event => {
    trackEvent(event, {
      zone: 'NewPermanentLinkModal',
      actionText: `generate new sessionChat link`,
    });

    updateJoinLink();

    setIsSubmitted(true);
  };

  useEffect(() => {
    const { new: error } = errors;
    if (isSubmitted && !isLoadingJoinLink) {
      if (error || errorsJoinLink) {
        showAlertToast(
          t('toasts.new_permanent_link.failure.title'),
          t('toasts.new_permanent_link.failure.text'),
          { toastId: 'newPermanentLinkFailed' },
        );
        setIsSubmitted(false);
        return;
      }
      showSuccessToast(t('toasts.new_permanent_link.success'), null, {
        toastId: 'newPermanentLinkSuccess',
      });
      handleClose();
    }
  }, [errors, isSubmitted, isLoadingJoinLink, errorsJoinLink]);

  return <NewPermanentLinkModal onClose={handleClose} onGenerateNew={handleGenerateNew} />;
};

export default NewPermanentLinkModule;
